// pdfStatusFilter.tsx
import type { IFilterParams, IFilterComp } from "ag-grid-community";

// 状态翻译映射函数
const translateStatus = (status: string): string => {
  // 由于这是一个类组件，无法直接使用useTranslation
  // 我们将使用浏览器语言或从window对象获取翻译函数
  const t = (window as any).__t || ((key: string) => key);

  switch (status) {
    case "all":
      return t("common.all") || "全部";
    case "重复文件":
      return t("admin.duplicateFile") || "重复文件";
    case "上传失败":
      return t("admin.uploadFailed") || "上传失败";
    case "超出大小":
      return t("admin.exceedsSize") || "超出大小";
    case "上传成功":
      return t("admin.uploadSuccess") || "上传成功";
    default:
      return status;
  }
};

export class CustomStatusFilterComponent implements IFilterComp {
  private eGui: HTMLElement | null = null;
  private selectedStatus: string | null = null;
  private filterParams: IFilterParams | null = null;
  private statusOptions: { value: string; label: string }[] = [
    { value: "重复文件", label: translateStatus("重复文件") },
    { value: "上传失败", label: translateStatus("上传失败") },
    { value: "超出大小", label: translateStatus("超出大小") },
    { value: "上传成功", label: translateStatus("上传成功") },
  ];
  private isInitialized: boolean = false;

  init(params: IFilterParams): void {
    this.filterParams = params;
    this.setupGui();
    this.isInitialized = true;
  }

  setupGui(): void {
    this.eGui = document.createElement("div");
    this.eGui.innerHTML = `
            <div style="padding: 8px; min-width: 100px; max-height: 300px; overflow-y: auto;">
                <div style="margin-bottom: 8px;">
                    <label style="display: flex; align-items: center; cursor: pointer;">
                        <input type="radio" name="status-filter" value="" style="margin-right: 8px;" checked />
                        <span>${translateStatus("all") || "全部"}</span>
                    </label>
                </div>
                <div style="border-top: 1px solid #e0e0e0; padding-top: 8px;" id="status-list">
                    ${this.statusOptions
                      .map(
                        (option) => `
                        <div style="margin-bottom: 6px;">
                            <label style="display: flex; align-items: center; cursor: pointer;">
                                <input type="radio" name="status-filter" value="${option.value}" style="margin-right: 8px;" />
                                <span>${option.label}</span>
                            </label>
                        </div>
                    `
                      )
                      .join("")}
                </div>
            </div>
        `;

    // 绑定事件
    const radios = this.eGui.querySelectorAll('input[type="radio"][name="status-filter"]');
    radios.forEach((radio) => {
      radio.addEventListener("change", (e) => {
        const target = e.target as HTMLInputElement;
        const value = target.value;
        this.handleStatusChange(value || null);
      });
    });

    // 设置默认选中状态
    this.selectedStatus = "";
  }

  handleStatusChange(status: string | null): void {
    // 只有在初始化完成后才处理状态变化
    if (!this.isInitialized) {
      return;
    }

    this.selectedStatus = status;
    this.filterParams?.filterChangedCallback();
  }

  getGui(): HTMLElement {
    return this.eGui as HTMLElement;
  }

  isFilterActive(): boolean {
    return this.selectedStatus !== null && this.selectedStatus !== "";
  }

  doesFilterPass(params: any): boolean {
    if (!this.selectedStatus || this.selectedStatus === "") {
      return true;
    }
    return params.data.status === this.selectedStatus;
  }

  getModel(): any {
    return this.selectedStatus && this.selectedStatus !== "" ? this.selectedStatus : null;
  }

  setModel(model: any): void {
    if (model && typeof model === "string") {
      this.selectedStatus = model;
    } else {
      this.selectedStatus = ""; // 设置为空字符串表示"全部"
    }

    // 更新UI
    const radios = this.eGui?.querySelectorAll('input[type="radio"][name="status-filter"]') || [];
    radios.forEach((radio) => {
      const input = radio as HTMLInputElement;
      input.checked = input.value === (this.selectedStatus || "");
    });
  }

  destroy(): void {
    this.isInitialized = false;
  }
}

export default CustomStatusFilterComponent;
